__turbopack_context__.v({
  "action": "FeaturedArticle-module-scss-module__32SbZG__action",
  "content": "FeaturedArticle-module-scss-module__32SbZG__content",
  "excerpt": "FeaturedArticle-module-scss-module__32SbZG__excerpt",
  "fade-in": "FeaturedArticle-module-scss-module__32SbZG__fade-in",
  "heading": "FeaturedArticle-module-scss-module__32SbZG__heading",
  "image": "FeaturedArticle-module-scss-module__32SbZG__image",
  "label": "FeaturedArticle-module-scss-module__32SbZG__label",
  "no-transform": "FeaturedArticle-module-scss-module__32SbZG__no-transform",
  "rotate": "FeaturedArticle-module-scss-module__32SbZG__rotate",
  "wrapper": "FeaturedArticle-module-scss-module__32SbZG__wrapper",
});
